// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-wrapper-hiding-wrapper-content-nlqpa{height:-moz-fit-content;height:fit-content;width:100%}.components-wrapper-hiding-wrapper-contentWrapper-sxdek{margin-bottom:12px;overflow:hidden;position:relative}.components-wrapper-hiding-wrapper-gradient-kmkgq{background:linear-gradient(180deg,rgba(206,46,103,0) -15.83%,#fff 123.33%);height:100%;left:0;position:absolute;top:0;width:100%}.components-wrapper-hiding-wrapper-showAll-btdbl{cursor:pointer;font-size:14px;text-decoration:underline;-webkit-text-decoration-style:dashed;text-decoration-style:dashed}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "components-wrapper-hiding-wrapper-content-nlqpa",
	"contentWrapper": "components-wrapper-hiding-wrapper-contentWrapper-sxdek",
	"gradient": "components-wrapper-hiding-wrapper-gradient-kmkgq",
	"showAll": "components-wrapper-hiding-wrapper-showAll-btdbl"
};
module.exports = ___CSS_LOADER_EXPORT___;
